import { render, staticRenderFns } from "./CuentaForm.vue?vue&type=template&id=a2312e78&"
import script from "./CuentaForm.vue?vue&type=script&lang=js&"
export * from "./CuentaForm.vue?vue&type=script&lang=js&"
import style0 from "./CuentaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports